import React, { useState } from 'react';
import { Section, Title } from './Styled';
import { theme } from '../theme';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const FAQ: React.FC = () => {
  const { language } = useLanguage();
  const t = translations.faq[language];
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <Section id="faq" bg={theme.colors.gray}>
      <Title style={{ color: theme.colors.white }}>{t.title}</Title>
      <div style={{ maxWidth: 720, width: '100%', margin: '0 auto' }}>
        {t.items.map((item, idx) => (
          <div key={idx} style={{ borderBottom: `1px solid ${theme.colors.border}` }}>
            <div
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '1.1rem 0',
                cursor: 'pointer',
                color: openIndex === idx ? theme.colors.green : theme.colors.white,
                fontWeight: 600,
                fontSize: 'clamp(0.95rem, 2.5vw, 1.05rem)',
                userSelect: 'none',
                transition: 'color 0.2s',
              }}
            >
              {item.q}
              <span style={{
                color: theme.colors.green,
                fontSize: '1.5rem',
                lineHeight: 1,
                flexShrink: 0,
                marginLeft: '1rem',
                display: 'inline-block',
                transform: openIndex === idx ? 'rotate(45deg)' : 'none',
                transition: 'transform 0.2s',
              }}>
                +
              </span>
            </div>
            {openIndex === idx && (
              <div style={{
                color: '#B7B7B7',
                fontSize: '0.97rem',
                lineHeight: 1.75,
                paddingBottom: '1.25rem',
              }}>
                {item.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </Section>
  );
};

export default FAQ;
